"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleDashboardFilter = exports.setSelectedView = exports.setPendingFilterChanges = exports.deleteDashboard = exports.editDashboard = exports.addDashboard = exports.updateDashboardSubscriptions = exports.getDashboardSubscriptions = exports.getDashboards = exports.setDashboardFilter = exports.setSelectedDashboard = void 0;

var _apiServices = require("@pingum/api-services");

var types = _interopRequireWildcard(require("./types"));

var _networkDispatcher = require("../networkDispatcher");

var _allEventsDashboard = _interopRequireDefault(require("./allEventsDashboard"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var setSelectedDashboard = function setSelectedDashboard(dashboard) {
  return {
    type: types.SET_DASHBOARD,
    dashboard: dashboard
  };
};

exports.setSelectedDashboard = setSelectedDashboard;

var setDashboardFilter = function setDashboardFilter(dashboard) {
  return {
    type: types.SET_DASHBOARD_FILTER,
    dashboard: dashboard
  };
};

exports.setDashboardFilter = setDashboardFilter;

var getDashboards = function getDashboards(directLink, queryParamView) {
  return function (dispatch) {
    var promise = _apiServices.DashboardService.getDashboards();

    promise.then(function (dashboards) {
      // only set a dashboard if it is requested/on dashboard page
      if (queryParamView !== undefined) {
        var foundDashboard = _allEventsDashboard["default"];
        [_allEventsDashboard["default"]].concat(_toConsumableArray(dashboards)).forEach(function (dashboard) {
          if (dashboard.directLinkName === directLink) {
            foundDashboard = dashboard;
          }
        });

        if (queryParamView) {
          foundDashboard.defaultView = queryParamView;
        }

        dispatch(setSelectedDashboard(foundDashboard));
      }
    })["catch"](function () {});
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_REQUESTED,
      successType: types.DASHBOARD_SUCCESS,
      errorType: types.DASHBOARD_ERROR,
      promise: promise,
      defaultErrorMessage: 'There was a problem loading all dashboards for the organization',
      responseName: 'dashboards'
    });
  };
};

exports.getDashboards = getDashboards;

var getDashboardSubscriptions = function getDashboardSubscriptions(dashboardId) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_SUBSCRIPTIONS_REQUESTED,
      successType: types.DASHBOARD_SUBSCRIPTIONS_SUCCESS,
      errorType: types.DASHBOARD_SUBSCRIPTIONS_ERROR,
      promise: _apiServices.DashboardService.getDashboardSubscriptions(dashboardId),
      defaultErrorMessage: 'There was a problem loading subscriptions for the dashboard',
      responseName: 'dashboardSubscriptions'
    });
  };
};

exports.getDashboardSubscriptions = getDashboardSubscriptions;

var updateDashboardSubscriptions = function updateDashboardSubscriptions(auth0UserId, request, successMessage) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_SUBSCRIPTIONS_EDIT_REQUESTED,
      successType: types.DASHBOARD_SUBSCRIPTIONS_EDIT_SUCCESS,
      errorType: types.DASHBOARD_SUBSCRIPTIONS_EDIT_ERROR,
      promise: _apiServices.EventSubscriptionService.updateEventSubscription(auth0UserId, request),
      successMessage: successMessage,
      defaultErrorMessage: 'There was a problem updating the dashboard subscription',
      responseName: 'eventSubscription'
    });
  };
};

exports.updateDashboardSubscriptions = updateDashboardSubscriptions;

var addDashboard = function addDashboard(newDashboardrequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_ADD_REQUESTED,
      successType: types.DASHBOARD_ADD_SUCCESS,
      errorType: types.DASHBOARD_ADD_ERROR,
      promise: _apiServices.DashboardService.addDashboard(newDashboardrequest),
      successMessage: 'Successfully created the dashboard',
      defaultErrorMessage: 'There was a problem adding the dashboard to the organization',
      responseName: 'newDashboard'
    });
  };
};

exports.addDashboard = addDashboard;

var editDashboard = function editDashboard(dashboardId, editDashboardRequest) {
  return function (dispatch) {
    (0, _networkDispatcher.dispatchNetworkRequest)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_EDIT_REQUESTED,
      successType: types.DASHBOARD_EDIT_SUCCESS,
      errorType: types.DASHBOARD_EDIT_ERROR,
      promise: _apiServices.DashboardService.editDashboard(dashboardId, editDashboardRequest),
      successMessage: 'Successfully updated the dashboard',
      defaultErrorMessage: 'There was a problem editing this dashboard',
      responseName: 'updatedDashboard'
    });
  };
};

exports.editDashboard = editDashboard;

var deleteDashboard = function deleteDashboard(dashboardId) {
  return function (dispatch) {
    var promise = _apiServices.DashboardService.deleteDashboard(dashboardId);

    promise.then(function () {
      dispatch(setSelectedDashboard(_allEventsDashboard["default"]));
    })["catch"](function () {});
    (0, _networkDispatcher.dispatchNetworkRequestDynamicSuccessDispatch)({
      dispatch: dispatch,
      requestType: types.DASHBOARD_DELETE_REQUESTED,
      successDispatch: {
        type: types.DASHBOARD_DELETE_SUCCESS,
        dashboardId: dashboardId
      },
      errorType: types.DASHBOARD_DELETE_ERROR,
      promise: promise,
      successMessage: 'Successfully deleted the dashboard',
      defaultErrorMessage: 'There was a problem deleting this dashboard',
      responseName: 'deleteResponse'
    });
  };
};

exports.deleteDashboard = deleteDashboard;

var setPendingFilterChanges = function setPendingFilterChanges() {
  return {
    type: types.DASHBOARD_FILTER_CHANGED
  };
};

exports.setPendingFilterChanges = setPendingFilterChanges;

var setSelectedView = function setSelectedView(selectedView) {
  return {
    type: types.DASHBOARD_VIEW_CHANGED,
    selectedView: selectedView
  };
};

exports.setSelectedView = setSelectedView;

var toggleDashboardFilter = function toggleDashboardFilter(state) {
  return {
    type: types.TOGGLE_DASHBOARD_FILTER,
    state: state
  };
};

exports.toggleDashboardFilter = toggleDashboardFilter;